import { css } from '@/styled-system/css';

/* 
  - Multiple badges are discouraged but we'll still accommodate them.
  - If badges run long, truncate them so they stay on one line and don't obscure the photo.
*/
export const propertyCardBadgeAreaStyles = css.raw({
  alignItems: 'start',
  columnGap: 'tightest',
  display: 'grid',
  gridAutoFlow: 'column',
});
